const KEY = "cookie_consent";

export function getConsent() {
  return sessionStorage.getItem(KEY);
}

export function setConsent(value) {
  if (value) {
    sessionStorage.setItem(KEY, value);
  } else {
    sessionStorage.removeItem(KEY);
  }
}
